import styled, { css } from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { views } from "../../Configs/config";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${(props) => (props?.view === views.MAP ? "35%" : 0)};
  overflow: hidden;
  padding-bottom: ${() => `${viewSizeCalculator(1)}`}; // optional padding
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  position: relative;
  transition: width 400ms ease-in-out;

  ${(props) =>
    props.isAtEnd &&
    css`
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${viewSizeCalculator(4.2)};
        background: linear-gradient(
          to top,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );
        pointer-events: none;
        border-bottom-left-radius: ${viewSizeCalculator(1.25)};
        border-bottom-right-radius: ${viewSizeCalculator(1.25)};
      }
    `}
`;

// Holds the panel content at a fixed width (the panel's open width) so that
// when MainContainer collapses to 0 the content is clipped by overflow:hidden
// instead of reflowing. Falls back to 100% until the open width is measured.
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${({ openWidth }) => (openWidth ? `${openWidth}px` : "100%")};
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${() => `${viewSizeCalculator(1.1)} ${viewSizeCalculator(1.25)} ${viewSizeCalculator(0.625)} ${viewSizeCalculator(1.25)}`};
`;

  export const Title = styled.div`
    font-size: ${() => `${viewSizeCalculator(18, true)}`};
    font-weight: 700;
    line-height: ${() => `${viewSizeCalculator(1.35)}`};
    color: #333333;
`;

export const Count = styled.span`
  font-size: ${() => `${viewSizeCalculator(22, true)}`}; // 1.25rem
  font-weight: 700;
  padding: ${() => `0 ${viewSizeCalculator(0.125)}`}; // 0 0.125rem
  color: ${({ isGray }) => (isGray ? "#a0a0a0" : "inherit")};
`;

export const Span = styled.span`
  font-size: ${({ fontSize }) => `${viewSizeCalculator(fontSize)}`};
  font-weight: ${({ fontWeight }) => fontWeight};
  padding: 0 0.1rem;
`;

export const FilterBox = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem;
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  border: ${() =>
    `${viewSizeCalculator(0.125)} solid #ebebeb`}; // 0.125rem solid #ebebeb;
  background-color: ${({ isDropdownOpen, isHovered }) =>
    isDropdownOpen || isHovered ? "#F6F6F6" : "#ffffff"};
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${({ isDisabled }) =>
      isDisabled ? "not-allowed" : "pointer"};
  position: relative;
  svg {
    opacity: ${({ isDisabled }) =>
      isDisabled ? "20%" : "1"};
    width: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
    height: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
  }
`;

export const CompareWrapper = styled(FilterBox)`
  svg {
    opacity: ${({ isDisabled }) =>
      isDisabled ? "20%" : "1"};
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 1.25rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 1.25rem;
  }
`

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  height: 100%;
  overflow-y: scroll;

  opacity: 0;
  animation: fadeIn 0.4s ease-in-out forwards;
  padding: ${() => `${viewSizeCalculator(0.625)} ${viewSizeCalculator(0.725)}`};

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`;

export const Footer = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ViewMoreButtonWrapper = styled.span`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.125)}`};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ViewMoreContent = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(0.7562)}`};
  opacity: 30%;
`;

export const PlayButtonWrapper = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: ${() => `${viewSizeCalculator(-0.3125)}`};
    width: ${() => `${viewSizeCalculator(0.625)}`};
    height: ${() => `${viewSizeCalculator(0.625)}`};
  }
`;
